import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { Observable } from 'rxjs';
import { getAvailablePaymentTerms } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/payment-terms.selector';
import { filter, map } from 'rxjs/operators';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

@Injectable()
export class PaymentTermsContractOptionLoaderOpenPlatformService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    const paymentTerms$ = this.store.pipe(
      select(getAvailablePaymentTerms),
      filter((data) => !!data),
      map((paymentTerms) => {
        const contractCode = formGroup.get(SpecFieldNames.CONTRACT_SELECT).value;
        if (paymentTerms.length > 0 && contractCode) {
          const defaultValue = paymentTerms[0].paymentTermCode;
          formGroup.get(SpecFieldNames.PAYMENT_TERMS).setValue(defaultValue);
          const options = paymentTerms.map((paymentTerm) => {
            return {
              id: paymentTerm.paymentTermCode,
              name: `${paymentTerm.paymentTermType.paymentTermTypeCode}`,
            };
          });
          return options;
        }
        return [];
      }),
    );
    return paymentTerms$;
  }
}
